import { useState } from "react";
import { formatDateShort } from "../../../../shared/types/date-helpers";
import { DatePicker } from "../../../../ui/atoms/DatePicker";

interface DateInputProps {
  readonly value: string;
  readonly onChange: (date: string) => void;
}

export function DateInput({ value, onChange }: DateInputProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="w-full px-3 py-2 md:px-2.5 md:py-1.5 text-xs md:text-xs text-ink bg-surface border border-border/60 rounded-md focus:outline-none focus:border-accent/60 text-left hover:border-accent/40 transition-colors min-h-[40px] md:min-h-0"
      >
        {value ? formatDateShort(value) : "Choisir une date"}
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/20"
            onClick={() => setIsOpen(false)}
          />
          <div className="relative z-10" onClick={(e) => e.stopPropagation()}>
            <DatePicker
              value={value}
              onChange={(date) => {
                if (date) {
                  onChange(date);
                }
                setIsOpen(false);
              }}
              onClose={() => setIsOpen(false)}
            />
          </div>
        </div>
      )}
    </>
  );
}
